import { render, staticRenderFns } from "./CIPTravelers.vue?vue&type=template&id=00a82824&"
import script from "./CIPTravelers.vue?vue&type=script&lang=js&"
export * from "./CIPTravelers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Avijeh.Projects\\Web-Solutions\\IPA.Naga.Web\\Themes\\Eavar.com.V2\\UINew\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a82824')) {
      api.createRecord('00a82824', component.options)
    } else {
      api.reload('00a82824', component.options)
    }
    module.hot.accept("./CIPTravelers.vue?vue&type=template&id=00a82824&", function () {
      api.rerender('00a82824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Js/Services/Tourism/Components/CIPTravelers.vue"
export default component.exports